import React, { useState } from 'react';
import Login from './pages/Login';
import EventsPage from './pages/EventsPage';
import PartnersPage from './pages/PartnersPage';
import AttractionsPage from './pages/AttractionsPage';
import OrganizersPage from './pages/OrganizersPage';

// Nav items visible to everyone
const NAV_ALL = [
  { key: 'events',      label: '📅 Eventi' },
  { key: 'partners',    label: '🏨 Hotel & Rist.' },
  { key: 'attractions', label: '🏛️ Attrazioni' },
];

// Nav items only for superadmin
const NAV_SUPERADMIN = [
  { key: 'organizers', label: '👤 Organizzatori' },
];

export default function App() {
  const [admin, setAdmin] = useState(() => {
    try {
      const token = localStorage.getItem('admin_token');
      const info  = localStorage.getItem('admin_info');
      return token ? { token, ...(info ? JSON.parse(info) : {}) } : null;
    } catch { return null; }
  });
  const [page, setPage] = useState('events');

  const isSuperadmin = admin?.role === 'superadmin';

  const handleLogin = (adminData) => {
    localStorage.setItem('admin_info', JSON.stringify(adminData));
    setAdmin(adminData);
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_info');
    setAdmin(null);
  };

  if (!admin) return <Login onLogin={handleLogin} />;

  const navItems = [...NAV_ALL, ...(isSuperadmin ? NAV_SUPERADMIN : [])];

  return (
    <div style={styles.layout}>
      <aside style={styles.sidebar}>
        {/* Logo Friulion */}
        <div style={styles.logoBlock}>
          <div style={styles.logoText}>🏃 FRIULION</div>
          <div style={styles.logoSub}>ATHLETICS · Admin</div>
        </div>

        {/* User info */}
        <div style={styles.userBlock}>
          <div style={styles.userAvatar}>{(admin.name || 'A')[0].toUpperCase()}</div>
          <div style={styles.userInfo}>
            <div style={styles.userName}>{admin.name || 'Admin'}</div>
            <div style={styles.userRole}>
              {isSuperadmin ? '⭐ Superadmin' : '👤 Organizzatore'}
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav style={{ flex: 1 }}>
          {/* Organizer notice */}
          {!isSuperadmin && (
            <div style={styles.organizerNotice}>
              ℹ️ Puoi modificare solo gli eventi a te assegnati
            </div>
          )}

          {navItems.map((n) => (
            <button
              key={n.key}
              style={{ ...styles.navBtn, ...(page === n.key ? styles.navBtnActive : {}) }}
              onClick={() => setPage(n.key)}
            >
              {n.label}
            </button>
          ))}
        </nav>

        <button style={styles.logoutBtn} onClick={logout}>
          🚪 Esci
        </button>
      </aside>

      <main style={styles.main}>
        {page === 'events'      && <EventsPage admin={admin} />}
        {page === 'partners'    && <PartnersPage />}
        {page === 'attractions' && <AttractionsPage />}
        {page === 'organizers'  && isSuperadmin && <OrganizersPage />}
      </main>
    </div>
  );
}

const styles = {
  layout:  { display: 'flex', minHeight: '100vh', background: '#F0F2F5' },
  sidebar: {
    width: 240, background: '#0D3B6E',
    display: 'flex', flexDirection: 'column',
    boxShadow: '4px 0 20px rgba(0,0,0,0.15)',
  },

  // Logo
  logoBlock: { padding: '24px 20px 16px', borderBottom: '1px solid rgba(255,255,255,0.1)' },
  logoText:  { color: '#fff', fontSize: 18, fontWeight: 900, letterSpacing: 2 },
  logoSub:   { color: '#F26522', fontSize: 10, fontWeight: 700, letterSpacing: 2, marginTop: 2 },

  // User info
  userBlock: {
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '14px 20px',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    marginBottom: 8,
  },
  userAvatar: {
    width: 36, height: 36, borderRadius: 18,
    background: '#F26522', color: '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: 900, fontSize: 16, flexShrink: 0,
  },
  userInfo:  {},
  userName:  { color: '#fff', fontSize: 13, fontWeight: 700 },
  userRole:  { color: 'rgba(255,255,255,0.5)', fontSize: 11, marginTop: 2 },

  // Organizer notice
  organizerNotice: {
    margin: '0 12px 8px',
    background: 'rgba(242,101,34,0.15)',
    border: '1px solid rgba(242,101,34,0.3)',
    borderRadius: 8, padding: '8px 10px',
    color: '#F26522', fontSize: 11, lineHeight: 1.4,
  },

  // Nav
  navBtn: {
    display: 'block', width: '100%', padding: '11px 20px',
    background: 'none', border: 'none',
    color: 'rgba(255,255,255,0.65)', textAlign: 'left',
    cursor: 'pointer', fontSize: 14,
    borderLeft: '3px solid transparent',
    transition: 'all 0.15s',
  },
  navBtnActive: {
    background: 'rgba(255,255,255,0.1)',
    color: '#fff', fontWeight: 700,
    borderLeft: '3px solid #F26522',
  },

  logoutBtn: {
    padding: '14px 20px', background: 'none', border: 'none',
    color: 'rgba(255,255,255,0.4)', textAlign: 'left',
    cursor: 'pointer', fontSize: 13,
    borderTop: '1px solid rgba(255,255,255,0.08)',
  },
  main: { flex: 1, overflow: 'auto' },
};
